import app from '../main';

export default message => {
  app.$bvToast.toast(message, {
    title: 'Запрос выполнен',
    variant: 'success',
    solid: true,
    autoHideDelay: 15000,
  });
};
